import { render, staticRenderFns } from "./PublipostageCandidature.vue?vue&type=template&id=81234bc0"
import script from "./PublipostageCandidature.vue?vue&type=script&lang=js"
export * from "./PublipostageCandidature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports